export default __webpack_public_path__ + "locales/si/InviteDialog.json?hash=9c824c5189e1293e84a38aa735e3b5b2";